import $ from 'jquery';

const defaults = {
  tier: '#tier_input',
  age: '#age_input',
  salary: '#salary_input',
  yos: '#service_input',
  recip: '#reciprocal_input',
  capMet: false,
};

function PensionCalc(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.$tier = this.settings.tier;
  this.$age = this.settings.age;
  this.$salary = this.settings.salary;
  this.$yos = this.settings.yos;
  this.$recip = this.settings.recip;
  this.$capMet = this.settings.capMet;
  this.init();
}

PensionCalc.prototype = {
  init() {
    this.$element.submit((event) => {
      event.preventDefault();

      const USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

      const $tier = parseInt($(this.$tier).val(), 10);
      // const $age = parseInt($(this.$age).val(), 10);
      const $age = Number(parseFloat($(this.$age).val()).toFixed(1));
      const $startingSalary = parseInt($(this.$salary).val(), 10);
      // const $yos = parseInt($(this.$yos).val(), 10);
      const $yos = Number(parseFloat($(this.$yos).val()).toFixed(1));
      let $recip = Number(parseFloat($(this.$recip).val()).toFixed(1));
      $recip = (isNaN($recip)) ? 0 : $recip;
      const $salaryCap = 127283.01;
      const $salary = this.determineCappedSalary($tier, $startingSalary, $salaryCap);
      const $retElig = this.retireElig($tier, $age, $yos, $recip);
      const $pensionPercent = this.calcPercent($yos);
      // const $displayPenPercent = ($pensionPercent * 100).toFixed(2);
      const $displayPenPercent = Math.round($pensionPercent * 100);
      // const $displaySalary = parseFloat(Math.round($salary * 100) / 100).toFixed(2);
      // const $displaySalary = $salary.toFixed(2);
      const $displaySalary = USD.format($salary);
      const $pensionAmt = $salary * $pensionPercent;
      // const $dispPensionAmt = parseFloat(Math.round($pensionAmt * 100) / 100).toFixed(2);
      // const $dispPensionAmt = $pensionAmt.toFixed(2);
      const $dispPensionAmt = USD.format($pensionAmt);
      const $monthlyPension = $pensionAmt / 12;
      // const $dispMoPension = parseFloat(Math.round($monthlyPension * 100) / 100).toFixed(2);
      // const $dispMoPension = $monthlyPension.toFixed(2);
      const $dispMoPension = USD.format($monthlyPension);
      const $reduction = this.ageReduction($age, $yos, $tier);
      // const $reductionPercentage = ((1 - $reduction) * 100).toFixed(2);
      const $reductionPercentage = Math.round((1 - $reduction) * 100);
      const $redPension = $pensionAmt * $reduction;
      const $monthlyRedPension = $redPension / 12;
      const $reducedPercent = $redPension / $salary;
      const $displayRedPercent = Math.round($reducedPercent * 100);
      // const $dispReduced = parseFloat(Math.round($redPension * 100) / 100).toFixed(2);
      // const $dispReduced = $redPension.toFixed(2);
      const $dispReduced = USD.format($redPension);
      // const $dispReducedMo = parseFloat(Math.round($monthlyRedPension * 100) / 100).toFixed(2);
      // const $dispReducedMo = $monthlyRedPension.toFixed(2);
      const $dispReducedMo = USD.format($monthlyRedPension);
      // const $dispSalaryCap = parseFloat(Math.round($salaryCap * 100) / 100).toFixed(2);
      // const $dispSalaryCap = $salaryCap.toFixed(2);
      const $dispSalaryCap = USD.format($salaryCap);
      // const $dispEnteredSal = parseFloat(Math.round($startingSalary * 100) / 100).toFixed(2);
      // const $dispEnteredSal = $startingSalary.toFixed(2);
      const $dispEnteredSal = USD.format($startingSalary);

      // this.displaySalaryCap(
      //   $tier,
      //   $startingSalary,
      //   $salaryCap,
      //   $dispEnteredSal,
      //   $dispSalaryCap,
      // );

      this.calcPension(
        $age,
        $yos,
        $recip,
        $dispEnteredSal,
        $dispSalaryCap,
        $salary,
        $tier,
        $retElig,
        $displaySalary,
        $displayPenPercent,
        $dispPensionAmt,
        $dispMoPension,
        $reduction,
        $reductionPercentage,
        $displayRedPercent,
        $dispReduced,
        $dispReducedMo,
      );
    });
  },

  // This function caps salary if the person is Tier 2.
  determineCappedSalary($tier, $startSal, $salCap) {
    let $cappedSalary;
    if (($tier === 2) && ($startSal > $salCap)) {
      $cappedSalary = $salCap;
      this.$capMet = true;
    } else {
      $cappedSalary = $startSal;
    }
    return $cappedSalary;
  },

  // This function verifies eligibility to retire.
  retireElig($tier, $age, $yos, $recip) {
    let $elig = true;
    const $totalYos = (isNaN($recip)) ? $yos : ($yos + $recip);
    if ($tier === 1 && $age < 55) {
      $elig = false;
    } else if ($tier === 1 && $age < 62 && $totalYos < 20) {
      $elig = false;
    } else if ($tier === 1 && $totalYos < 5) {
      $elig = false;
    } else if ($tier === 2 && $age < 62) {
      $elig = false;
    } else if ($tier === 2 && $totalYos < 10) {
      $elig = false;
    }
    return $elig;
  },

  // This function calculates the pension percentage that will be applied to FAS to
  // calculate pension if pension percentage has not been maxed out.
  calcPercent2($yos) {
    const $perc = $yos * 0.022;
    return $perc;
  },

  // This function determines if the member has maxed out the pension percentage, and if not,
  // calls the calcPercent2 function to calculate it.
  calcPercent($yos) {
    const $perc = ($yos >= 33.95) ? 0.75 : this.calcPercent2($yos);
    return $perc;
  },

  // This function calculates the pension reduction, if applicable.
  reductionValue($age, $tier) {
    let $reductionAmt;
    if ($tier === 1) {
      $reductionAmt = (60 - $age) * 0.06;
    } else {
      $reductionAmt = (67 - $age) * 0.06;
    }
    const $pensionReduction = 1 - $reductionAmt;
    return $pensionReduction;
  },

  // This function determines if a reduction due to age is applicable.
  ageReduction($age, $yos, $tier) {
    let $ageRed = this.reductionValue($age, $tier);
    if ($tier === 1 && $age >= 62) {
      $ageRed = 1;
    } else if ($tier === 1 && $age >= 55 && $yos >= 33.95) {
      $ageRed = 1;
    } else if ($tier === 1 && $age >= 60 && $yos >= 20) {
      $ageRed = 1;
    } else if ($tier === 2 && $age >= 67) {
      $ageRed = 1;
    }
    return $ageRed;
  },

  resultsDisplay(perc, an, mo, msg) {
    $(document.getElementById('penCalcPerc')).html(perc);
    $(document.getElementById('penCalcAnnual')).html(an);
    $(document.getElementById('penCalcMonthly')).html(mo);
    $(document.getElementById('penCalcDetails')).html(msg);
  },

  // This function displays the pension.
  displayCalc(
    $age,
    $yos,
    $recip,
    $dispEnteredSal,
    $dispSalaryCap,
    $displaySalary,
    $displayPenPercent,
    $dispPensionAmt,
    $dispMoPension,
    $reduction,
    $reductionPercentage,
    $displayRedPercent,
    $dispReduced,
    $dispReducedMo,
  ) {
    const maxYos = 'Based on the total years of service you entered, your benefit may be reduced. <br><br>';

    const noQual = 'Your percentage was reduced for early retirement. Based on the data you provided, '
      + `if you qualified for an unreduced pension of ${$displayPenPercent}%, your total annual pension `
      + `would be ${$dispPensionAmt}. This is a monthly benefit of ${$dispMoPension}. <br><br>`;

    let message = '';

    if (this.$capMet) {
      message += `Under the Tier 2 benefits system, your final average salary may not exceed ${$dispSalaryCap}.  `
      + 'The salary used in this calculation has been adjusted to reflect this limitation. <br><br>';
    }

    if (($yos + $recip) >= 34) {
      message += maxYos;
    }

    if ($reduction !== 1) {
      message += noQual;
      this.resultsDisplay($displayRedPercent, $dispReduced, $dispReducedMo, message);
    } else {
      // message += yesQual;
      this.resultsDisplay($displayPenPercent, $dispPensionAmt, $dispMoPension, message);
    }
  },

  calcPension(
    $age,
    $yos,
    $recip,
    $dispEnteredSal,
    $dispSalaryCap,
    $salary,
    $tier,
    $retElig,
    $newSalary,
    $displayPenPercent,
    $dispPensionAmt,
    $dispMoPension,
    $reduction,
    $reductionPercentage,
    $displayRedPercent,
    $dispReduced,
    $dispReducedMo,
  ) {
    let message;

    $(document.getElementById(this.$age.slice(1))).removeClass('error');
    $(document.getElementById(this.$salary.slice(1))).removeClass('error');
    $(document.getElementById(this.$yos.slice(1))).removeClass('error');
    $(document.getElementById(this.$recip.slice(1))).removeClass('error');

    if (typeof $age !== 'number' || $age === '' || isNaN($age)) {
      message = 'You have not entered a valid age.';
      $(document.getElementById(this.$age.slice(1))).addClass('error');
      this.resultsDisplay(0, 'n/a', 'n/a', message);
    } else if (typeof $salary !== 'number' || $salary === '' || isNaN($salary)) {
      message = 'You have not entered a valid salary.  Salary must be a whole number.  Do not use commas, '
        + 'dollar signs, or decimal places.';
      $(document.getElementById(this.$salary.slice(1))).addClass('error');
      this.resultsDisplay(0, 'n/a', 'n/a', message);
    } else if (typeof $yos !== 'number' || $yos === '' || isNaN($yos)) {
      message = 'Your entry for years of CTPF service is invalid.  Years of service must be in numbers.';
      $(document.getElementById(this.$yos.slice(1))).addClass('error');
      this.resultsDisplay(0, 'n/a', 'n/a', message);
    } else if (typeof $recip !== 'number' || $recip === '' || isNaN($recip)) {
      message = 'Your entry for years of reciprocal service is invalid.  Years of service must be in numbers.';
      $(document.getElementById(this.$recip.slice(1))).addClass('error');
      this.resultsDisplay(0, 'n/a', 'n/a', message);
    } else if ($tier === 1 && $retElig === false) {
      message = 'According to the information you entered, you would not be eligible to retire from CTPF '
        + 'with a Tier 1 benefit.  In order to retire from CTPF, you need to be at least age 55.  If you are '
        + 'under age 62, you need at least 20 years of service credit in order to retire.  At or after age 62, '
        + 'you need at least 5 years of service to retire.';
      this.resultsDisplay(0, 'n/a', 'n/a', message);
    } else if ($tier === 2 && $retElig === false) {
      message = 'According to the information you entered, you would not be eligible to retire from CTPF '
        + 'with a Tier 2 benefit.  In order to retire from CTPF, you need to be at least age 62.  You need at '
        + 'least 10 years of service credit in order to retire.';
      this.resultsDisplay(0, 'n/a', 'n/a', message);
    } else {
      this.displayCalc(
        $age,
        $yos,
        $recip,
        $dispEnteredSal,
        $dispSalaryCap,
        $newSalary,
        $displayPenPercent,
        $dispPensionAmt,
        $dispMoPension,
        $reduction,
        $reductionPercentage,
        $displayRedPercent,
        $dispReduced,
        $dispReducedMo,
      );
    }
    this.$capMet = false;
  },
};

export default PensionCalc;
